import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { color, spacing, border } from '@metro-ui/tokens/js';
import { fontStack } from '../utils/fontStack';
import { mq } from '../utils/mediaQuery';
import { MaxSizedDiv } from '../utils/MaxSizedDiv';
export var Footer = styled(function (_a) {
    var className = _a.className, children = _a.children, _b = _a.maxWidth, maxWidth = _b === void 0 ? 1920 : _b, htmlAttributes = __rest(_a, ["className", "children", "maxWidth"]);
    return (React.createElement("footer", __assign({}, htmlAttributes, { className: className }),
        React.createElement(MaxSizedDiv, { maxWidth: maxWidth, style: { display: 'flex' } }, children)));
})(function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    width: 100%;\n    padding: ", " ", ";\n    border-top: ", " solid ", ";\n\n    ", " {\n      padding: ", " ", ";\n      border-top: 0;\n      min-height: 3rem;\n    }\n  "], ["\n    ", "\n    width: 100%;\n    padding: ", " ", ";\n    border-top: ", " solid ", ";\n\n    ", " {\n      padding: ", " ", ";\n      border-top: 0;\n      min-height: 3rem;\n    }\n  "])), fontStack, spacing['x-small'], spacing['xx-small'], border.width.thin, color.palette.grey.tint[90], mq('m'), spacing['xx-small'], spacing.medium); });
Footer.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1;
//# sourceMappingURL=Footer.js.map